var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgUseraacountEnterprise = function SvgUseraacountEnterprise(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "useraacount_enterprise_svg__useraacount_enterprise_svg__cls-2",
    d: "M12.343 19.985c-.114.005-.227.015-.343.015a7.893 7.893 0 01-4.93-1.72c.43-.9 3.05-1.78 4.93-1.78.062 0 .13.009.194.01a5.967 5.967 0 01.88-1.93A9.554 9.554 0 0012 14.5c-1.46 0-4.93.59-6.36 2.33A7.994 7.994 0 1120 12c0 .116-.01.229-.015.343a5.984 5.984 0 011.9 1.09 10.084 10.084 0 10-8.452 8.453 5.985 5.985 0 01-1.09-1.9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "useraacount_enterprise_svg__useraacount_enterprise_svg__cls-2",
    d: "M12 6a3.5 3.5 0 103.5 3.5A3.491 3.491 0 0012 6zm0 5a1.5 1.5 0 111.5-1.5A1.498 1.498 0 0112 11z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18 14a4 4 0 104 4 4 4 0 00-4-4zm-.208 7.206v-2.509h-1.395l2.004-3.903v2.509h1.343z",
    fill: "#6cb8ef"
  })));
};
export default SvgUseraacountEnterprise;